<template>
    <div class="p-md m-b-md">
        <div class="app-block p-md">
            <h3 class="heading-line title is-4 has-text-weight-light"><span
                    :class="'school-title-'+schoolSlug">Projet</span></h3>
            <div v-if="motivations && motivations.length > 400">
                <div :class="motivationHidden" v-html="motivations">


                </div>
                <span class="is-link" @click="toggleText">[...]</span>
            </div>
            <div v-else>
                <div v-html="motivations">


                </div>
            </div>
            <div class="has-text-right">
                <button class="button" @click="edit"
                        v-if="!this.application.application_complete">Modifier
                </button>
            </div>
        </div>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                motivations: '',
                textHidden: true
            }
        },
        props: {
            school: { type: Object },
            schoolSlug: { type: String },
            candidate: { type: Object },
            application: {type: Object},
        },
        computed: {
            motivationHidden: function () {
                return this.textHidden ? 'text-hidden' : ''
            }
        },
        methods: {
            edit: function () {
                this.$emit('edit')
            },
            toggleText () {
                this.textHidden = !this.textHidden
            }
        },
        created: function () {
            this.motivations = this.application.motivation
        }
    }
</script>
